<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        class="LIST"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedtext"
        @load="getList"
        :immediate-check="false"
        offset="200"
        :style="{ 'padding-bottom': paddingBottom + 'px' }"
      >
        <div>
          <Loading v-if="pageLoading" />
          <div v-if="!pageLoading">
            <slot />
          </div>
        </div>
        <div slot="finished">
          <div>
            {{ finishedtext }}
          </div>
          <slot name="finished" />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: "zdyList",
  props: {
    paddingBottom: {
      default: 0,
    },
    list: {
      default: [],
    },
    finishedText: {
      default: "没有更多了",
    },
    params: {
      default: () => {
        return { page: 1, perPage: 10 };
      },
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      Allchecked: true,
      param: this.params,
      refreshing: false,
      pageLoading: false,
      isCloseLoad: false,
    };
  },
  computed: {
    finishedtext() {
      if (this.isCloseLoad) {
        var text = "";
      } else {
        var text = this.list.length > 3 ? this.finishedText : "";
      }
      return text;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.onRefresh();
  },
  methods: {
    // onRefresh() {
    //   console.log("onRefresh");
    //   // 清空列表数据
    //   // 重新加载数据
    //   this.reset();
    //   setTimeout(() => {
    //     this.GetUserAdvance();
    //     this.getList();
    //   }, 0);
    // },
    getList() {
      if (this.param.page == 1) this.pageLoading = true;
      this.$parent.onLoad(this.param);
    },
    reset() {
      this.refreshing = false;
      this.param.page = 1;
      if (!this.isCloseLoad) this.finished = false;
      this.loading = true;
    },
    onRefresh() {
      this.reset();
      this.getList();
    },
    //关闭上拉加载，保持下拉刷新
    closeLoad() {
      this.isCloseLoad = true;
      this.errorloading();
    },
    //出错时调用
    errorloading() {
      this.pageLoading = false;
      this.finished = true;
      this.refreshing = false;
      this.loading = false;
    },

    //通过布尔值确定是否下一页
    EndByBoolean(ismore) {
      if (ismore == true) {
        this.param.page += 1;
      } else {
        this.finished = true;
      }
      this.pageLoading = false;
      this.refreshing = false;
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.notice {
  height: 34px;
  background: #fdeeed;
  font-size: 14px;
  font-weight: 400;
  color: #f05c51;
  line-height: 20px;
  display: flex;
  align-items: center;
  padding-left: 21px;
}
.travel-list {
  // padding-bottom: 100px;
}
.bottom-check {
  position: fixed;
  bottom: 0;
  height: 70px;
  width: 375px;
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.12);
}
.LIST {
  min-height: 80vh;
}
</style>